import { api } from "./api";

export const companyDataApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCompanyData: builder.query<any, void>({
      query: () => "api/Sys/Company",
      providesTags: ["companyData"],
    }),
    saveCompanyData: builder.mutation<any, Partial<any>>({
      query: (formData) => ({
        url: "api/Sys/Company",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["companyData"],
    }),
  }),
});

export const { useGetCompanyDataQuery, useSaveCompanyDataMutation } =
  companyDataApi;
